export default "__VITE_ASSET__BF33RgFt__"